import React from "react";
import styled from "styled-components";

import img1 from "./img-1.jpg";
import img2 from "./img-2.jpg";
import img3 from "./img-3.jpg";
import img4 from "./img-4.jpg";

const Products = () => {
  const [portrait, setPortrait] = React.useState(false);
  const scrollRight = (dir) => {
    if (portrait === false) {
      const pw = document.getElementById("pw");
      const pc = document.getElementById("pc");
      if (window.innerWidth > window.innerHeight) {
        pw.scrollLeft = pw.scrollLeft + pc.offsetWidth * 1.08 * dir;
      } else {
        pw.scrollLeft = pw.scrollLeftMax;
      }
    }
  };
  let direction;
  let timer;
  React.useEffect(() => {
    timer = 0;
    direction = 1;
    setInterval(() => {
      if (portrait === false) {
        scrollRight(direction);
        timer++;
        if (timer === 4) {
          direction = direction * -1;
          timer = 0;
        }
        console.log(timer);
      }
    }, 3500);
  }, []);
  React.useEffect(() => {
    setInterval(() => {
      if (window.innerWidth > window.innerHeight) {
        setPortrait(false);
      } else if (window.innerWidth <= window.innerHeight) {
        setPortrait(true);
      }
    }, 250);
  }, []);
  return (
    <>
      {portrait === false ? (
        <div id="products">
          <ProductsSentence>Culpa perferendis excepturi.</ProductsSentence>
          <ProductsTitle>Our Products</ProductsTitle>
          <ProductsWrapper id="pw">
            <ProductsGrid>
              <ProductsCard id="pc">
                <ProductsImage src={img1} />
                <PCardTitle>Fuga asperiores</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
              <ProductsCard>
                <ProductsImage src={img2} />
                <PCardTitle>Voluptatibus iure!</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
              <ProductsCard>
                <ProductsImage src={img3} />
                <PCardTitle>Autem minus animi</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
              <ProductsCard>
                <ProductsImage src={img4} />
                <PCardTitle>Sed eligendi</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
              <ProductsCard>
                <ProductsImage src={img1} />
                <PCardTitle>Fuga asperiores</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
              <ProductsCard>
                <ProductsImage src={img2} />
                <PCardTitle>Voluptatibus iure!</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
            </ProductsGrid>
          </ProductsWrapper>
        </div>
      ) : (
        <div id="products">
          <ProductsSentence>Culpa perferendis excepturi.</ProductsSentence>
          <ProductsTitle>Our Products</ProductsTitle>
          <ProductsWrapper id="pw">
            <ProductsGrid>
              <ProductsCard id="pc">
                <ProductsImage src={img1} />
                <PCardTitle>Fuga asperiores</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
              <ProductsCard>
                <ProductsImage src={img2} />
                <PCardTitle>Voluptatibus iure!</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
              <ProductsCard>
                <ProductsImage src={img3} />
                <PCardTitle>Autem minus animi</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
              <ProductsCard>
                <ProductsImage src={img4} />
                <PCardTitle>Sed eligendi</PCardTitle>
                <PCardContent>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </PCardContent>
              </ProductsCard>
            </ProductsGrid>
          </ProductsWrapper>
        </div>
      )}
    </>
  );
};

const ProductsWrapper = styled.div`
  width: 100vw;
  height: 60vh;
  background-color: whitesmoke;
  overflow-x: hidden;
  overflow-y: scroll;
  cursor: grab;
  user-select: none;
  scroll-behavior: smooth;

  @media screen and (orientation: portrait) {
    height: 170vh;
  }
`;

const ProductsSentence = styled.h1`
  margin: 0;
  color: gray;
  font-size: 0.9vw;
  font-weight: 400;
  margin-left: 15vw;
  padding-top: 2vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 1.75vh;
    margin-left: 10vw;
  }
`;
const ProductsTitle = styled.h1`
  margin: 0;
  font-size: 2vw;
  color: black;
  font-weight: 500;
  margin-left: 15vw;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 4.25vh;
    margin-left: 10vw;
  }
`;

const ProductsGrid = styled.div`
  width: 148vw;
  height: 60vh;
  overflow-x: auto;

  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(1, 1fr);
  justify-items: center;
  align-items: center;

  @media screen and (orientation: portrait) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(4, 1fr);
    overflow-x: hidden;
    overflow-y: hidden;
    height: 165vh;
    width: 100vw;
    margin-top: 5vh;
  }
`;

const ProductsCard = styled.div`
  width: 23vw;
  height: 40vh;
  transform: translateY(-5vh);

  display: flex;
  flex-direction: column;

  @media screen and (orientation: portrait) {
    width: 75vw;
  }
`;

const ProductsImage = styled.img`
  width: 23vw;
  height: 32vh;

  @media screen and (orientation: portrait) {
    width: 75vw;
    height: 28vh;
  }
`;

const PCardTitle = styled.h1`
  color: #f53b4d;
  margin: 0;
  font-size: 1vw;
  font-weight: 500;
  padding-top: 1vh;

  @media screen and (orientation: portrait) {
    font-size: 3vh;
  }
`;

const PCardContent = styled.h2`
  color: gray;
  opacity: 0.7;
  margin: 0;
  font-size: 0.8vw;
  font-weight: 500;
  padding-top: 1vh;

  @media screen and (orientation: portrait) {
    font-size: 1.65vh;
  }
`;

export default Products;
